import { useRef } from 'react';
import { useEmbedBoundaries } from '@utils/component-framework';
import { Component } from './component.js';
import { jsx } from 'react/jsx-runtime';

function FlashcardEmbedContent(props) {
  const embedRef = useRef(null);
  useEmbedBoundaries(embedRef);
  return /*#__PURE__*/jsx(Component, {
    ...props,
    ref: embedRef,
    enableElementToolbar: props.context === "embedded"
  });
}

export { FlashcardEmbedContent };
//# sourceMappingURL=integration.embed.js.map
